import { useState, useEffect } from 'react';
import axios from 'axios';
import { Cloud, CloudOff } from 'lucide-react';
import { api } from '../../utils/api';

export function NgrokStatus() {
  const [status, setStatus] = useState<'checking' | 'active' | 'inactive'>('checking');
  const [url, setUrl] = useState('');

  useEffect(() => {
    // Solo verificar si estamos corriendo en local
    const isLocal = window.location.hostname === 'localhost' || 
                    window.location.hostname === '127.0.0.1' || 
                    window.location.hostname.startsWith('192.168.');
                    
    if (!isLocal) {
      setStatus('inactive');
      return;
    }

    const checkStatus = async () => {
      try {
        const { data } = await api.get('/system/ngrok-status');
        if (data.active) {
          setStatus('active');
          setUrl(data.url);
        } else {
          setStatus('inactive');
        }
      } catch (err) {
        setStatus('inactive');
      }
    };

    checkStatus();
    const interval = setInterval(checkStatus, 30000); // Check every 30s
    
    return () => clearInterval(interval);
  }, []);

  if (status === 'checking') return null;

  return (
    <div 
      className="hidden md:flex items-center gap-2 px-3 py-1.5 rounded-full border border-border text-xs font-medium"
      title={status === 'active' ? `Menú QR activo en: ${url}` : 'Túnel Ngrok apagado. El menú QR no funciona.'}
    >
      {status === 'active' ? (
        <>
          <Cloud className="w-4 h-4 text-emerald-500" />
          <span className="text-emerald-600 dark:text-emerald-400">Túnel Activo</span>
        </>
      ) : (
        <>
          <CloudOff className="w-4 h-4 text-red-500" />
          <span className="text-red-600 dark:text-red-400">Túnel Inactivo</span>
        </>
      )}
    </div>
  );
}
